module.exports = __webpack_public_path__ + "static/img/KV_cn@3x.e13c757.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/KV_cn@3x.png
// module id = dd6W
// module chunks = 1